
import React, {useState} from 'react';
import Modal from '@mui/material/Modal';
import {Box, Button, Checkbox, createTheme, IconButton, List, ListItem, ThemeProvider} from "@mui/material";

import SyncAltIcon from '@mui/icons-material/SyncAlt';

import "./ExpenseModal.css";
import {EXPENSE_MODAL_DATA} from "../mock/MockData";

export default function ExpenseModal(props) {

    function buildState(data) {

        let copy = {...data};
        let keys = Object.keys(copy);

        for (let idx in keys) {
            let key = keys[idx];

            copy[key].checked = false;
        }

        return copy;
    }

    const handleManifestCreationResponse = (response) => {

        if (response.success) {
            manifestCreationCallback();
        }
    }

    const persistExpenses = () => {

        fetch("/api/v1/persistExpenseManifest", {
            method: 'POST',
            headers: {
                'Accept': 'application/json, text/plain, */*',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(expenseMap)
        })
            .then(response => response.json())
            .then(response => handleManifestCreationResponse(response))
            .catch(error => showError(error));

        return true;
    }

    const showError = () => {
        console.warn("Implement Error");
    }

    const closeWithoutUpdate = () => {
        manifestCreationCallback(false);
    }

    const handleClose = () => {

        persistExpenses();
    }

    const handleToggle = (obj) => {

        let copy = {...checks};
        if (copy[obj] === undefined) {
            copy[obj] = true;
        }
        else {
            copy[obj] = !copy[obj];
        }

        setChecks(copy);
    }

    const handleUpdate = () => {

        let map = {...expenseMap};
        let keys = Object.keys(checks);

        for (let idx in keys) {
            let key = keys[idx];

            map[key].payroll = !map[key].payroll;
        }

        setChecks({});
        setExpenseMap(map);
    }

    const buildExpenseMap = (expenses) => {

        let map = {};

        for (let idx in expenses) {
            let obj = expenses[idx];

            if (obj.payroll === undefined) {
                obj.payroll = false;
            }

            map[obj.value] = obj;
        }

        return map;
    }

    const sortRows = (rows) => {
        rows.sort();

        return rows;
    }

    const generateCheckRows = (isPayroll, expenseMap) => {

        let rows = [];
        let keys = Object.keys(expenseMap);
        let count = 0;

        keys = sortRows(keys);

        for (let idx in keys) {
            let key = keys[idx];
            let obj = expenseMap[key];

            if (obj.payroll === isPayroll) {
                rows.push(buildCheck(count, obj));
                count++;
            }
        }

        return rows;
    }

    const buildCheck = (idx, obj) => {

        return <ListItem
            key={"expense_" + idx}
            sx={{bgcolor: (idx & 1) === 0 ? "#DDDDDD" : "#FFFFFF"}}
            secondaryAction={
                <Checkbox
                    edge="end"
                    onChange={() => handleToggle(obj.value)}
                    checked={checks[obj.value] !== undefined && checks[obj.value]}
                />
            }
        >
            <span key={obj.id}>{obj.value}</span>
        </ListItem>
    }

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 800,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4
    };


    const data = props.manifest ? props.manifest : [];
    const [expenses] = useState(props.expenses ? props.expenses : data);
    const [expenseMap, setExpenseMap] = useState(buildExpenseMap(expenses));
    const manifestCreationCallback = props.callback ? props.callback : () => console.warn("Manifest Creation callback not set.");
    const [checks, setChecks] = useState({});

    console.log(checks);

    const theme = createTheme({

        palette: {
            primary: {
                main: "#000000"
            },
        }
    });

    return (
        <React.Fragment>
            <div>
                <Modal
                    open={true}
                >
                    <Box sx={style}>
                        <div className={"expensemodal-container"}>
                            <div className={"expensemodal-columnar-container"}>
                                <div className={"expensemodal-header"}>
                                    Payroll Expenses
                                </div>
                                <div style={{overflowY: "auto", maxHeight: window.innerHeight - 200}} >
                                    <List dense sx={{width: '100%', bgcolor: 'background.paper'}}>
                                        {generateCheckRows(true, expenseMap)}
                                    </List>
                                </div>
                            </div>
                            <div className={"expensemodal-controls"}>
                                <div>
                                    <div>
                                        <IconButton
                                            size={'small'}
                                            sx={{border: "solid 1px", borderRadius: 0}}
                                            onClick={handleUpdate}
                                        >
                                            <SyncAltIcon/>
                                        </IconButton>
                                    </div>
                                </div>
                            </div>
                            <div className={"expensemodal-columnar-container"}>
                                <div className={"expensemodal-header"}>
                                    General Expenses
                                </div>
                                <div style={{overflowY: "auto", maxHeight: window.innerHeight - 200}} >
                                    <List dense sx={{width: '100%', bgcolor: 'background.paper'}}>
                                        {generateCheckRows(false, expenseMap)}
                                    </List>
                                </div>
                            </div>
                        </div>
                        <ThemeProvider theme={theme}>
                            <div className={"expensemodal-button"}>
                                <Button style={{width: "200px", marginRight: "20px"}} color={"primary"} variant={"outlined"} onClick={closeWithoutUpdate}>Cancel</Button>
                                <Button style={{width: "200px"}} color={"primary"} variant={"outlined"} onClick={handleClose}>Confirm Settings</Button>
                            </div>
                        </ThemeProvider>
                    </Box>
                </Modal>
            </div>
        </React.Fragment>
    )
}